module.exports = __webpack_public_path__ + "img/index_group2.335faea8.png";